<div ngbAccordion #acc="ngbAccordion" [id]="innerId" [attr.data-st-theme]="theme">
    <ng-container *ngFor="let item of items | orderByImpure : 'order'; let index = index">
        <div
            ngbAccordionItem="{{ innerId }}-{{ index }}"
            [collapsed]="actualActiveIds.includes('{{ innerId }}-{{ index }}')"
        >
            <div ngbAccordionHeader>
                <button ngbAccordionButton>{{ item.label }}</button>
            </div>

            <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                    <ng-container
                        [ngTemplateOutlet]="contentTemplate"
                        [ngTemplateOutletContext]="{ $implicit: item }"
                    ></ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</div>
